import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, ArrowLeft } from '@phosphor-icons/react';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Universal "Back to Home" button — used in every internal page header.
 * - Always navigates to `/home` (the post-login dashboard, NOT `/` which is the public landing page).
 * - Icon flips automatically based on language direction:
 *     RTL (ar) → ArrowRight (the back direction in Arabic reading order)
 *     LTR (en) → ArrowLeft
 * - Pass `className` to override colour to match the page's theme.
 */
export default function BackButton({ className = 'text-[#655dc6]', iconSize = 20, testId = 'back-btn' }) {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const isAr = language === 'ar';

  return (
    <Button
      variant="ghost"
      onClick={() => navigate('/home')}
      className={`gap-2 ${className}`}
      data-testid={testId}
    >
      {isAr
        ? <ArrowRight size={iconSize} weight="bold" />
        : <ArrowLeft size={iconSize} weight="bold" />}
      {isAr ? 'رجوع' : 'Back'}
    </Button>
  );
}
